import React from "react";
import { observer } from "mobx-react";
import Loader from "@app/components/loader/content";

const Callback = observer(() => {
    window.close();

    return (
        <div className="sso-callback auth" style={{ marginTop: "48vh" }}>
            <Loader loading />
        </div>
    );
});

export default Callback;
